import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api";
import { hideLoader, showLoader } from "./loaderSlice";

export const getPetsAllReportData = createAsyncThunk(
  "getPetsAllReportData",
  async (data = { type: "pets" }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/pets-data`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch pets data");
    }
  },
);

export const getPetsReportData = createAsyncThunk(
  "getPetsReportData",
  async (data = { type: "pets" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/pets-data`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch pets data");
    }
  },
);

export const getPetsAllAppointmentsReportData = createAsyncThunk(
  "getPetsAllAppointmentsReportData",
  async (data = { type: "appointments" }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/pets-data`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch pets data");
    }
  },
);

export const getPetsAppointmentsReportData = createAsyncThunk(
  "getPetsAppointmentsReportData",
  async (data = { type: "appointments" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/pets-data`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch pets data");
    }
  },
);

export const getVetsRevenueReportData = createAsyncThunk(
  "getVetsRevenueReportData",
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/consultations`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet revenue data");
    }
  },
);

export const getVetsRevenueAllReportData = createAsyncThunk(
  "getVetsRevenueAllReportData",
  async (data = { type: "revenue" }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/consultations`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet revenue data");
    }
  },
);

export const getVetsSpecialityReportData = createAsyncThunk(
  "getVetsSpecialityReportData",
  async (data = { type: "speciality" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/consultations`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet speciality data");
    }
  },
);

export const getVetsSlotsReportData = createAsyncThunk(
  "getVetsSlotsReportData",
  async (data = { type: "slots" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/consultations`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet slots data");
    }
  },
);

export const getVetsDelaysReportData = createAsyncThunk(
  "getVetsDelaysReportData",
  async (url = "?type=delay", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/consultations${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet delay data");
    }
  },
);

export const getVetsUpcomingsReportData = createAsyncThunk(
  "getVetsUpcomingsReportData",
  async (data = { type: "upcoming" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/consultations`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch vet upcoming data");
    }
  },
);

export const getAppointmentsTableReportData = createAsyncThunk(
  "getAppointmentsTableReportData",
  async (data = { type: "appointments", itemSize: 10, page: 1 }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/appointments/comprehensive`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch appointment data");
    }
  },
);

export const getAppointmentsFacilityReportData = createAsyncThunk(
  "getAppointmentsFacilityReportData",
  async (data = { type: "facility", page: 1, itemSize: 10 }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/appointments/comprehensive`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch facility data");
    }
  },
);

export const getAllBillingRevenueReportData = createAsyncThunk(
  "getAllBillingRevenueReportData",
  async (data = {}, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/billing/revenue-dump`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch billing revenue data");
    }
  },
);

export const getBillingRevenueReportData = createAsyncThunk(
  "getBillingRevenueReportData",
  async (data = { page: 1, itemSize: 10 }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/billing/revenue-dump`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch billing revenue data");
    }
  },
);

export const getBillingSalesReturnReportData = createAsyncThunk(
  "getBillingSalesReturnReportData",
  async (url = "?purchaseType=Sales", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/billing/revenue-dump${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch billing return data");
    }
  },
);

export const getBillingPurchaseReturnReportData = createAsyncThunk(
  "getBillingPurchaseReturnReportData",
  async (url = "?purchaseType=Purchase", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/billing/revenue-dump${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch billing return data");
    }
  },
);

export const getAllStockDumpReportData = createAsyncThunk(
  "getAllStockDumpReportData",
  async (data = { type: "dump" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/inventory/stock`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch stock dump data");
    }
  },
);

export const getStockDumpReportData = createAsyncThunk(
  "getStockDumpReportData",
  async (data = { type: "dump" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/inventory/stock`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch stock dump data");
    }
  },
);

export const getAllStockBatchReportData = createAsyncThunk(
  "getAllStockBatchReportData",
  async (data = { type: "batch" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/inventory/stock`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch stock batch data");
    }
  },
);

export const getStockBatchReportData = createAsyncThunk(
  "getStockBatchReportData",
  async (data = { type: "batch" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/inventory/stock`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch stock batch data");
    }
  },
);

export const getStockReturnReportData = createAsyncThunk(
  "getStockReturnReportData",
  async (url = "?type=returns", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/dashboard/inventory/stock${url}`,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch stock return data");
    }
  },
);

export const getAllServiceTableReportData = createAsyncThunk(
  "getAllServiceTableReportData",
  async (data = { type: "summary" }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/services/table-data`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        // thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      // thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch service report data");
    }
  },
);

export const getServiceTableReportData = createAsyncThunk(
  "getServiceTableReportData",
  async (data = { type: "summary", page: 1, itemSize: 10 }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/services/table-data`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch service report data");
    }
  },
);

export const getAllServiceAppointmentsReportData = createAsyncThunk(
  "getAllServiceAppointmentsReportData",
  async (data = { type: "detail" }, thunkAPI) => {
    try {
      // thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/services/table-data`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        // thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      // thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      // thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch service report data");
    }
  },
);

export const getServiceAppointmentsReportData = createAsyncThunk(
  "getServiceAppointmentsReportData",
  async (data = { type: "detail" }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/clinic/dashboard/services/table-data`,
        data,
      );
      if (res.status === 200 || res?.payload === 201) {
        thunkAPI.dispatch(hideLoader());
        return res.data;
      }
      thunkAPI.dispatch(hideLoader());
      return {};
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch service report data");
    }
  },
);

export const getSalesReturnReportData = createAsyncThunk(
  "getSalesReturnReportData",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/appointment/clinic/payments${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

export const getPurchaseReturnReportData = createAsyncThunk(
  "getPurchaseReturnReportData",
  async (url = "", thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        `/clinic/supplier${url}`,
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data;
      } else if (res.status !== 200) {
        thunkAPI.dispatch(hideLoader());
      }
      thunkAPI.dispatch(hideLoader());
      return null;
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
    }
  },
);

const reportSlice = createSlice({
  name: "report",
  initialState: {
    allPets: {},
    pets: {},
    allAppointments: {},
    appointments: {},
    vetRevenue: {},
    vetRevenueAll: {},
    vetSpeciality: {},
    vetSlots: {},
    vetDelays: {},
    vetUpcomings: {},
    appointmentTable: {},
    appoinmentFacility: {},
    billingRevenueAll: {},
    billingRevenue: {},
    billingSalesReturn: {},
    billingPurchaseReturn: {},
    allServiceTable: {},
    serviceTable: {},
    allServiceAppointments: {},
    serviceAppointments: {},
    stockDumpAll: {},
    stockDump: {},
    stockBatchAll: {},
    stockBatch: {},
    stockReturn: {},
    salesReturn: {},
    purchaseReturn: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPetsAllReportData.fulfilled, (state, action) => {
      state.allPets = action.payload ?? {};
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getPetsReportData.fulfilled, (state, action) => {
      state.pets = action.payload ?? {};
      state.loading = false;
      state.error = null;
    });
    builder.addCase(
      getPetsAllAppointmentsReportData.fulfilled,
      (state, action) => {
        state.allAppointments = action.payload ?? {};
        state.loading = false;
        state.error = null;
      },
    );
    builder.addCase(
      getPetsAppointmentsReportData.fulfilled,
      (state, action) => {
        state.appointments = action.payload ?? {};
        state.loading = false;
        state.error = null;
      },
    );
    builder.addCase(getVetsRevenueReportData.fulfilled, (state, action) => {
      state.vetRevenue = action.payload ?? {};
    });
    builder.addCase(getVetsRevenueAllReportData.fulfilled, (state, action) => {
      state.vetRevenueAll = action.payload ?? {};
    });
    builder.addCase(getVetsSpecialityReportData.fulfilled, (state, action) => {
      state.vetSpeciality = action.payload ?? {};
    });
    builder.addCase(getVetsSlotsReportData.fulfilled, (state, action) => {
      state.vetSlots = action.payload ?? {};
    });
    builder.addCase(getVetsDelaysReportData.fulfilled, (state, action) => {
      state.vetDelays = action.payload ?? {};
    });
    builder.addCase(getVetsUpcomingsReportData.fulfilled, (state, action) => {
      state.vetUpcomings = action.payload ?? {};
    });
    builder.addCase(
      getAppointmentsTableReportData.fulfilled,
      (state, action) => {
        state.appointmentTable = action.payload ?? {};
      },
    );
    builder.addCase(
      getAppointmentsFacilityReportData.fulfilled,
      (state, action) => {
        state.appoinmentFacility = action.payload ?? {};
      },
    );
    builder.addCase(
      getAllBillingRevenueReportData.fulfilled,
      (state, action) => {
        state.billingRevenueAll = action.payload ?? {};
      },
    );
    builder.addCase(getBillingRevenueReportData.fulfilled, (state, action) => {
      state.billingRevenue = action.payload ?? {};
    });
    builder.addCase(
      getBillingSalesReturnReportData.fulfilled,
      (state, action) => {
        state.billingSalesReturn = action.payload ?? {};
      },
    );
    builder.addCase(
      getBillingPurchaseReturnReportData.fulfilled,
      (state, action) => {
        state.billingPurchaseReturn = action.payload ?? {};
      },
    );
    builder.addCase(getAllStockDumpReportData.fulfilled, (state, action) => {
      state.stockDumpAll = action.payload ?? {};
    });
    builder.addCase(getStockDumpReportData.fulfilled, (state, action) => {
      state.stockDump = action.payload ?? {};
    });
    builder.addCase(getAllStockBatchReportData.fulfilled, (state, action) => {
      state.stockBatchAll = action.payload ?? {};
    });
    builder.addCase(getStockBatchReportData.fulfilled, (state, action) => {
      state.stockBatch = action.payload ?? {};
    });
    builder.addCase(getStockReturnReportData.fulfilled, (state, action) => {
      state.stockReturn = action.payload ?? {};
    });
    builder.addCase(getAllServiceTableReportData.fulfilled, (state, action) => {
      state.allServiceTable = action.payload ?? {};
    });
    builder.addCase(getServiceTableReportData.fulfilled, (state, action) => {
      state.serviceTable = action.payload ?? {};
    });
    builder.addCase(
      getAllServiceAppointmentsReportData.fulfilled,
      (state, action) => {
        state.allServiceAppointments = action.payload ?? {};
      },
    );
    builder.addCase(
      getServiceAppointmentsReportData.fulfilled,
      (state, action) => {
        state.serviceAppointments = action.payload ?? {};
      },
    );
    builder.addCase(getSalesReturnReportData.fulfilled, (state, action) => {
      state.salesReturn = action.payload ?? {};
    });
    builder.addCase(getPurchaseReturnReportData.fulfilled, (state, action) => {
      state.purchaseReturn = action.payload ?? {};
    });
  },
});

export default reportSlice.reducer;
